/* 🤖 this file was generated by svg-to-ts */
export const matIconTexture: {
  name: 'texture';
  data: string;
} = {
  name: 'texture',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19.51 3.08 3.08 19.51c.09.34.27.65.51.9.25.24.56.42.9.51L20.93 4.49c-.19-.69-.73-1.23-1.42-1.41zM11.88 3 3 11.88v2.83L14.71 3h-2.83zM5 3c-1.1 0-2 .9-2 2v2l4-4H5zm14 18c.55 0 1.05-.22 1.41-.59.37-.36.59-.86.59-1.41v-2l-4 4h2zm-9.71 0h2.83L21 12.12V9.29L9.29 21z"/></svg>`
};
